import api from '@/shared/api/api';
import { AccessService } from '@/shared/api/protocol-ts/api/core/svc_access_connectweb';
import {
  AcceptSharingReq,
  AcceptSharingResp,
  RevokeSharingReq,
  RevokeSharingResp,
  InviteStaffReq,
  InviteStaffResp,
  SharePatientReq,
  SharePatientResp,
  CancelSharingInvitationReq,
  CancelSharingInvitationResp,
  GetInvitationByTokenReq,
  GetInvitationByTokenResp,
  SetOrganizationStaffRoleReq,
  SetOrganizationStaffRoleResp,
  RemoveOrganizationStaffReq,
  RemoveOrganizationStaffResp,
  SetPatientTeamMembersReq,
  SetPatientTeamMembersResp,
} from '@/shared/api/protocol-ts/api/core/svc_access_pb';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

type AccessRequests = keyof typeof AccessService.methods;

const generateAccessThunk = createThunkGenerator<AccessRequests>(
  SliceName.access,
);

export const setOrganizationStaffRole = generateAccessThunk<
  SetOrganizationStaffRoleReq,
  SetOrganizationStaffRoleResp
>('setOrganizationStaffRole', api.access.setOrganizationStaffRole);

export const removeOrganizationStaff = generateAccessThunk<
  RemoveOrganizationStaffReq,
  RemoveOrganizationStaffResp
>('removeOrganizationStaff', api.access.removeOrganizationStaff);

export const setPatientTeamMembers = generateAccessThunk<
  SetPatientTeamMembersReq,
  SetPatientTeamMembersResp
>('setPatientTeamMembers', api.access.setPatientTeamMembers);

export const revokeSharing = generateAccessThunk<
  RevokeSharingReq,
  RevokeSharingResp
>('revokeSharing', api.access.revokeSharing);

export const cancelSharingInvitation = generateAccessThunk<
  CancelSharingInvitationReq,
  CancelSharingInvitationResp
>('cancelSharingInvitation', api.access.cancelSharingInvitation);

export const inviteStaff = generateAccessThunk<InviteStaffReq, InviteStaffResp>(
  'inviteStaff',
  api.access.inviteStaff,
);

export const inviteForSharingPatient = generateAccessThunk<
  SharePatientReq,
  SharePatientResp
>('sharePatient', api.access.sharePatient);

export const acceptSharing = generateAccessThunk<
  AcceptSharingReq,
  AcceptSharingResp
>('acceptSharing', api.access.acceptSharing);

export const getInvitationByToken = generateAccessThunk<
  GetInvitationByTokenReq,
  GetInvitationByTokenResp
>('getInvitationByToken', api.access.getInvitationByToken);
